/*
 *
 * Date: 2025
 * Description: Main components for part display
 * Author: Philippe Leroux @SKITSC
 *
 */

//Modules
import { Box , Typography , Grid, Tooltip } from "@mui/material";
import { ReactElement } from "react";

//Interfaces
import { i_view_part_props } from "../../interfaces/display.interfaces";

//Utils
import { formatTimestamp } from "../../utils/utility";
import { useViewModal } from "../../context/view.modal.context";

const ViewPartCard = ( props : i_view_part_props) : ReactElement => {
    const { showPartModal } = useViewModal()
    const C = props.part
    const V = props.part.vendors
    const UPLOAD_PATH = process.env.REACT_APP_API_URL ?  process.env.REACT_APP_API_URL : ''
    const PRE_PATH = process.env.REACT_APP_PREPATH ? process.env.REACT_APP_PREPATH : ''
    return(
        <Box sx={{ width : '100%' ,}}>
            <Box sx={{ border : '1px solid #EAECF0' , padding : 1 }}>
                    <Grid container>
                        <Grid size={{ xl : 1.5 , lg : 2, md : 2.5, xs : 12}}>
                            <Box sx={{ maxWidth: 140, maxHeight: 70, display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }} onClick={() => showPartModal(C.path)} >
                                <Box component="img" sx={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain'}} src={UPLOAD_PATH + PRE_PATH + '/uploads/parts/' + C.path} />
                            </Box>
                        </Grid>
                        <Grid size={{ xl : 6.5 , lg : 6 , md : 3.5, xs : 12}}>
                            <Typography sx={{ fontSize : 17 , marginLeft : '10px'}}>{C.description}</Typography>
                            <Typography sx={{ textDecoration : 'underline' , fontWeight : 800 , marginLeft : '10px'}}>{C.sku}</Typography>
                        </Grid>
                        <Grid size={{ xl : 2 , lg : 2 ,md : 3, xs : 12}}>
                            <Box sx={{ display : 'flex' , flexDirection : 'column'}}>
                               
                                {V.tiger.length > 0 &&
                                    <Tooltip title={V.tiger[0].timestamp!== undefined? formatTimestamp(V.tiger[0].timestamp) + " Tigerparts price"  : 'No date'}>
                                        <Typography>T : {V.tiger[0].price}</Typography>
                                    </Tooltip>
                                }
                                {V.lkq.length > 0 &&
                                    <Tooltip title={V.lkq[0].timestamp!== undefined? formatTimestamp(V.lkq[0].timestamp) + " Lkq price" : 'No date'}>
                                        <Typography>L : {V.lkq[0].price}</Typography>
                                    </Tooltip>
                                }
                                {V.moneydex.length > 0 &&
                                    <Tooltip title={V.moneydex[0].timestamp!== undefined? formatTimestamp(V.moneydex[0].timestamp) + " moneydex price"  : 'No date'}>
                                        <Typography>M : {V.moneydex[0].price}</Typography>
                                    </Tooltip>
                                }
                            </Box>
                        </Grid>
                        <Grid size={{ xl : 2 , lg: 2,  md : 3, xs : 12}}>
                                {V.rockauto.length > 0 &&
                                    <Tooltip title={V.rockauto[0].timestamp!== undefined? formatTimestamp(V.rockauto[0].timestamp) + " rockauto price"  : 'No date'}>
                                        <Typography>R : {V.rockauto[0].price}</Typography>
                                    </Tooltip>
                                }
                                {V.atpac.length > 0 &&
                                    <Tooltip title={V.atpac[0].timestamp!== undefined? formatTimestamp(V.atpac[0].timestamp) + " atpac price"  : 'No date'}>
                                        <Typography>A : {V.atpac[0].price}</Typography>
                                    </Tooltip>
                                }
                        </Grid>
                      
                    </Grid>
            </Box>
        </Box>
    )
}

export default ViewPartCard;